$(function() {
    var $successContactFeedback = $('#success-contact-feedback');

    if($successContactFeedback.length && window.location.href.includes('?contact_posted=true')) {
        window.setTimeout(function(){
            $successContactFeedback.addClass('showing');
        }, 500);

        window.setTimeout(function(){
            $successContactFeedback.removeClass('showing');
        }, 4500);
    }
});
